define("shared/components/shared/post/secondary/caption-writer/list-item", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "moment", "shared/utils/caption-writer/format-tone-for-segment", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _moment, _formatToneForSegment, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _getDelimiter, _getUpdatedCaption, _setDefaultCaption, _setFirstComment, _setPostCaption;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"moment",0,"shared/utils/caption-writer/format-tone-for-segment",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.hasGeneratedText}}
    <li class={{concat-classes "tCW--listItem" (if this.hasBeenInserted "is--added") "qa--aiCaptions_caption"}}>
      {{! Insert Button }}
      <Shared::Ui::Button
        @class="tCW--listItem__addCaptionBtn qa--aiCaptions_insertBtn"
        @variant="unstyled"
        data-generated-caption-id={{@generatedCaption.id}}
        data-test-id="generated-captions-list-item-insert-button"
        onClick={{fn this.insertGeneratedCaption @generatedCaption}}
      >
        <p class="tCW--listItem__actionLabel">
          {{#if this.hasBeenInserted}}
            <span class="u--text--success">
              {{t "caption_writer.caption_actions.inserted_caption"}}
              {{svg-jar "check" class="o--icon--sm u--m__l__xs"}}
            </span>
          {{else}}
            <span>{{t "caption_writer.caption_actions.insert_caption"}}</span>
            {{svg-jar "add-circle" class="o--icon--sm u--m__l__xs"}}
          {{/if}}
        </p>
  
        {{! Caption }}
        <Shared::ExpandableTruncatedText
          @maximumLength={{this.maximumGeneratedTextLength}}
          @text={{@generatedCaption.generatedText}}
          class="tCW--listItem__caption"
        />
      </Shared::Ui::Button>
  
      {{! Refine Caption }}
      <div>
        <Shared::Ui::Button
          @additional="rounded"
          @class="tCW--listItem__controlBtn qa--aiCaptions_rephraseBtn"
          @isDisabled={{not this.canRefineCaption}}
          @onClick={{perform this.refine (hash type="rephrase")}}
          @variant="outline"
        >
          {{svg-jar "sparkle" class="o--icon--sm"}}
          <span>
            {{t "caption_writer.refine_captions.rephrase"}}
          </span>
        </Shared::Ui::Button>
        <Shared::Ui::Button
          @additional="rounded"
          @class="tCW--listItem__controlBtn qa--aiCaptions_casualToneBtn"
          @isDisabled={{not this.canRefineCaption}}
          @onClick={{perform this.refine (hash type="tone" value="casual")}}
          @variant="outline"
        >
          {{svg-jar "tone-casual" class="o--icon--sm"}}
          <span>
            {{t "caption_writer.refine_captions.casual_detailed"}}
          </span>
        </Shared::Ui::Button>
        <Shared::Ui::Button
          @additional="rounded"
          @class="tCW--listItem__controlBtn qa--aiCaptions_proToneBtn"
          @isDisabled={{not this.canRefineCaption}}
          @onClick={{perform this.refine (hash type="tone" value="professional")}}
          @variant="outline"
        >
          {{svg-jar "tone-professional" class="o--icon--sm"}}
          <span>
            {{t "caption_writer.refine_captions.professional_detailed"}}
          </span>
        </Shared::Ui::Button>
        <Shared::Ui::Button
          @additional="rounded"
          @class="tCW--listItem__controlBtn qa--aiCaptions_customToneBtn"
          @isDisabled={{not this.canRefineCaption}}
          @onClick={{this.toggleCustomToneFormVisibility}}
          @variant="outline"
        >
          {{svg-jar "tones" class="o--icon--sm"}}
          <span>
            {{t "caption_writer.refine_captions.custom_detailed"}}
          </span>
          {{#if this.isCustomToneSelected}}
            {{svg-jar "verified-solid" class="o--icon--sm o--icon--hl"}}
          {{/if}}
        </Shared::Ui::Button>
      </div>
  
      {{#if this.isCustomToneSelected}}
        <Input
          @value={{this.customTone}}
          class={{concat-classes
            "o--form__input"
            "tCW--form__input"
            (if this.customToneValidationError "has--error qa--error_border")
            "qa--aiCaptions_tone_txtBox"
          }}
          data-test-id="caption-refinement-form-custom-tone-input"
          disabled={{this.isCustomToneFormDisabled}}
          id="listItemCustomTone"
          name="listItemCustomTone"
          placeholder={{t "caption_writer.form.tone_placeholder"}}
          {{autofocus}}
          {{on "input" this.onInputCustomTone}}
        />
        {{#if this.customToneValidationError}}
          <p
            class="tCW--form__helperText--error qa--error_inline_warning qa--error_border"
            data-test-id="caption-refinement-form-custom-tone-input-error"
          >
            {{this.customToneValidationError}}
          </p>
        {{/if}}
        <Shared::Ui::Button
          @additional="rounded"
          @class={{concat-classes
            "o--btn--block u--m__tb"
            "qa--aiCaptions_refineBtn"
            (unless this.canRefineCaption "qa--aiCaptions_refineBtn_disabled")
          }}
          @isDisabled={{or this.customToneValidationError (not this.customTone) (not this.canRefineCaption)}}
          @onClick={{perform this.refine (hash type="tone" value=this.customTone)}}
          @size="small"
          data-test-id="caption-refinement-form-submit"
        >
          {{t "caption_writer.button_cta"}}
          {{svg-jar "ai" class="o--icon u--m__l__xs"}}
        </Shared::Ui::Button>
      {{/if}}
  
      {{! No Credits CTA }}
      {{#if @shouldDisplayNoRemainingCaptions}}
        <p class="u--text--sm u--m__tb__sm">
          {{#if this.isEnterpriseSubscription}}
            {{html-safe (t "caption_writer.get_more_credits_enterprise" contact_url=this.enterpriseContactUrl)}}
          {{else}}
            {{t "caption_writer.no_credits_left"}}
            <Shared::Ui::Button
              @class="u--text--success"
              @onClick={{@showCreditPurchase}}
              @text={{t "caption_writer.get_more_credits"}}
              @variant="actionLink"
            />
          {{/if}}
        </p>
      {{/if}}
  
      <hr class="u--m__t__xs u--m__b__sm" />
  
      {{! Delete Caption }}
      <div class="u--text--right">
        <Shared::Ui::Button
          @class="u--text--sm u--text--light qa--aiCaptions_deleteBtn"
          @onClick={{fn @hideGeneratedCaption @generatedCaption.id}}
          @variant="actionLink"
        >
          {{svg-jar "trash" class="o--icon--sm"}}
          {{t "caption_writer.caption_actions.delete_caption"}}
        </Shared::Ui::Button>
      </div>
    </li>
  {{else}}
    <li
      class="tCW--listItem is--loading"
      data-generated-caption-id={{@generatedCaption.id}}
      data-test-id="captions-list-item-loading"
    >
      <Shared::LoadingSpinner />
    </li>
  {{/if}}
  */
  {
    "id": "jP/ZovPh",
    "block": "[[[41,[30,0,[\"hasGeneratedText\"]],[[[1,\"  \"],[10,\"li\"],[15,0,[28,[37,1],[\"tCW--listItem\",[52,[30,0,[\"hasBeenInserted\"]],\"is--added\"],\"qa--aiCaptions_caption\"],null]],[12],[1,\"\\n\"],[1,\"    \"],[8,[39,2],[[16,\"data-generated-caption-id\",[30,1,[\"id\"]]],[24,\"data-test-id\",\"generated-captions-list-item-insert-button\"],[16,\"onClick\",[28,[37,3],[[30,0,[\"insertGeneratedCaption\"]],[30,1]],null]]],[[\"@class\",\"@variant\"],[\"tCW--listItem__addCaptionBtn qa--aiCaptions_insertBtn\",\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"tCW--listItem__actionLabel\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasBeenInserted\"]],[[[1,\"          \"],[10,1],[14,0,\"u--text--success\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"caption_writer.caption_actions.inserted_caption\"],null]],[1,\"\\n            \"],[1,[28,[35,5],[\"check\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[12],[1,[28,[35,4],[\"caption_writer.caption_actions.insert_caption\"],null]],[13],[1,\"\\n          \"],[1,[28,[35,5],[\"add-circle\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\\n\"],[1,\"      \"],[8,[39,6],[[24,0,\"tCW--listItem__caption\"]],[[\"@maximumLength\",\"@text\"],[[30,0,[\"maximumGeneratedTextLength\"]],[30,1,[\"generatedText\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[1,\"    \"],[10,0],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"rounded\",\"tCW--listItem__controlBtn qa--aiCaptions_rephraseBtn\",[28,[37,7],[[30,0,[\"canRefineCaption\"]]],null],[28,[37,8],[[30,0,[\"refine\"]],[28,[37,9],null,[[\"type\"],[\"rephrase\"]]]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"sparkle\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"caption_writer.refine_captions.rephrase\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[39,2],null,[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"rounded\",\"tCW--listItem__controlBtn qa--aiCaptions_casualToneBtn\",[28,[37,7],[[30,0,[\"canRefineCaption\"]]],null],[28,[37,8],[[30,0,[\"refine\"]],[28,[37,9],null,[[\"type\",\"value\"],[\"tone\",\"casual\"]]]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"tone-casual\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"caption_writer.refine_captions.casual_detailed\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[39,2],null,[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"rounded\",\"tCW--listItem__controlBtn qa--aiCaptions_proToneBtn\",[28,[37,7],[[30,0,[\"canRefineCaption\"]]],null],[28,[37,8],[[30,0,[\"refine\"]],[28,[37,9],null,[[\"type\",\"value\"],[\"tone\",\"professional\"]]]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"tone-professional\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"caption_writer.refine_captions.professional_detailed\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[39,2],null,[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"rounded\",\"tCW--listItem__controlBtn qa--aiCaptions_customToneBtn\",[28,[37,7],[[30,0,[\"canRefineCaption\"]]],null],[30,0,[\"toggleCustomToneFormVisibility\"]],\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"tones\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"caption_writer.refine_captions.custom_detailed\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"isCustomToneSelected\"]],[[[1,\"          \"],[1,[28,[35,5],[\"verified-solid\"],[[\"class\"],[\"o--icon--sm o--icon--hl\"]]]],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isCustomToneSelected\"]],[[[1,\"      \"],[8,[39,10],[[16,0,[28,[37,1],[\"o--form__input\",\"tCW--form__input\",[52,[30,0,[\"customToneValidationError\"]],\"has--error qa--error_border\"],\"qa--aiCaptions_tone_txtBox\"],null]],[24,\"data-test-id\",\"caption-refinement-form-custom-tone-input\"],[16,\"disabled\",[30,0,[\"isCustomToneFormDisabled\"]]],[24,1,\"listItemCustomTone\"],[24,3,\"listItemCustomTone\"],[16,\"placeholder\",[28,[37,4],[\"caption_writer.form.tone_placeholder\"],null]],[4,[38,11],null,null],[4,[38,12],[\"input\",[30,0,[\"onInputCustomTone\"]]],null]],[[\"@value\"],[[30,0,[\"customTone\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"customToneValidationError\"]],[[[1,\"        \"],[10,2],[14,0,\"tCW--form__helperText--error qa--error_inline_warning qa--error_border\"],[14,\"data-test-id\",\"caption-refinement-form-custom-tone-input-error\"],[12],[1,\"\\n          \"],[1,[30,0,[\"customToneValidationError\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[8,[39,2],[[24,\"data-test-id\",\"caption-refinement-form-submit\"]],[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@size\"],[\"rounded\",[28,[37,1],[\"o--btn--block u--m__tb\",\"qa--aiCaptions_refineBtn\",[52,[51,[30,0,[\"canRefineCaption\"]]],\"qa--aiCaptions_refineBtn_disabled\"]],null],[28,[37,14],[[30,0,[\"customToneValidationError\"]],[28,[37,7],[[30,0,[\"customTone\"]]],null],[28,[37,7],[[30,0,[\"canRefineCaption\"]]],null]],null],[28,[37,8],[[30,0,[\"refine\"]],[28,[37,9],null,[[\"type\",\"value\"],[\"tone\",[30,0,[\"customTone\"]]]]]],null],\"small\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,4],[\"caption_writer.button_cta\"],null]],[1,\"\\n        \"],[1,[28,[35,5],[\"ai\"],[[\"class\"],[\"o--icon u--m__l__xs\"]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,2],[[[1,\"      \"],[10,2],[14,0,\"u--text--sm u--m__tb__sm\"],[12],[1,\"\\n\"],[41,[30,0,[\"isEnterpriseSubscription\"]],[[[1,\"          \"],[1,[28,[35,15],[[28,[37,4],[\"caption_writer.get_more_credits_enterprise\"],[[\"contact_url\"],[[30,0,[\"enterpriseContactUrl\"]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,4],[\"caption_writer.no_credits_left\"],null]],[1,\"\\n          \"],[8,[39,2],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--text--success\",[30,3],[28,[37,4],[\"caption_writer.get_more_credits\"],null],\"actionLink\"]],null],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,\"hr\"],[14,0,\"u--m__t__xs u--m__b__sm\"],[12],[13],[1,\"\\n\\n\"],[1,\"    \"],[10,0],[14,0,\"u--text--right\"],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"u--text--sm u--text--light qa--aiCaptions_deleteBtn\",[28,[37,3],[[30,4],[30,1,[\"id\"]]],null],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"trash\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n        \"],[1,[28,[35,4],[\"caption_writer.caption_actions.delete_caption\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,\"li\"],[14,0,\"tCW--listItem is--loading\"],[15,\"data-generated-caption-id\",[30,1,[\"id\"]]],[14,\"data-test-id\",\"captions-list-item-loading\"],[12],[1,\"\\n    \"],[8,[39,16],null,null,null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"@generatedCaption\",\"@shouldDisplayNoRemainingCaptions\",\"@showCreditPurchase\",\"@hideGeneratedCaption\"],false,[\"if\",\"concat-classes\",\"shared/ui/button\",\"fn\",\"t\",\"svg-jar\",\"shared/expandable-truncated-text\",\"not\",\"perform\",\"hash\",\"input\",\"autofocus\",\"on\",\"unless\",\"or\",\"html-safe\",\"shared/loading-spinner\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/list-item.hbs",
    "isStrictMode": false
  });
  const INSERTED_CAPTION_SEGMENT_EVENT = 'inserted-ai-caption';
  const MAXIMUM_DISPLAYED_CAPTION_LENGTH = 300;
  let ListItemComponent = _exports.default = (_class = (_getDelimiter = /*#__PURE__*/new WeakSet(), _getUpdatedCaption = /*#__PURE__*/new WeakSet(), _setDefaultCaption = /*#__PURE__*/new WeakSet(), _setFirstComment = /*#__PURE__*/new WeakSet(), _setPostCaption = /*#__PURE__*/new WeakSet(), class ListItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _setPostCaption);
      _classPrivateMethodInitSpec(this, _setFirstComment);
      _classPrivateMethodInitSpec(this, _setDefaultCaption);
      _classPrivateMethodInitSpec(this, _getUpdatedCaption);
      _classPrivateMethodInitSpec(this, _getDelimiter);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _initializerDefineProperty(this, "hasBeenInserted", _descriptor6, this);
      _initializerDefineProperty(this, "customTone", _descriptor7, this);
      _initializerDefineProperty(this, "isCustomToneSelected", _descriptor8, this);
      _initializerDefineProperty(this, "isCustomToneDirty", _descriptor9, this);
      _defineProperty(this, "maximumGeneratedTextLength", MAXIMUM_DISPLAYED_CAPTION_LENGTH);
      _defineProperty(this, "emberDropFocused", false);
      _defineProperty(this, "refine", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (args) {
          yield this.args.onRefinement?.({
            generatedCaption: this.args.generatedCaption,
            type: args.type,
            value: args.type === 'tone' ? args.value : undefined,
            groupTone: this.args.groupTone
          });
          if (this.isCustomToneSelected) {
            this.isCustomToneDirty = false;
            this.customTone = '';
            this.isCustomToneSelected = false;
          }
          let element;
          if (args.type === 'tone') {
            element = document.getElementById('scroll-to-top-caption-writer');
          } else {
            element = document.getElementById(this.args.captionGroupScrollTarget);
          }
          element && element.scrollIntoView();
        }
      }), null, "refine", null));
    }
    get defaultSegmentAttributes() {
      return {
        ...this.args.defaultSegmentAttributes,
        'ai-caption-id': this.args.generatedCaption.id,
        variant: this.args.generatedCaption.variant
      };
    }
    get isClickedFromFirstComment() {
      return this.secondaryModal.isClickedFromFirstComment(this.args.postElementId);
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get canRefineCaption() {
      return !this.args.shouldDisplayNoRemainingCaptions && !this.refine.isRunning;
    }
    get enterpriseContactUrl() {
      return this.subscriptions.enterpriseContactUrl;
    }
    get hasGeneratedText() {
      return Boolean(this.args.generatedCaption.generatedText?.length);
    }
    get customToneValidationError() {
      if (!this.isCustomToneSelected || !this.isCustomToneDirty) {
        return '';
      }
      if (!this.customTone.length) {
        return this.intl.t('caption_writer.validations.presence');
      }
      if (this.customTone.length < 3 || this.customTone.length > 20) {
        return this.intl.t('caption_writer.validations.length');
      }
      return '';
    }
    get isCustomToneFormDisabled() {
      return this.refine.isRunning;
    }
    toggleCustomToneFormVisibility() {
      if (this.isCustomToneSelected) {
        this.isCustomToneDirty = false;
        this.customTone = '';
      }
      this.isCustomToneSelected = !this.isCustomToneSelected;
    }
    onInputCustomTone() {
      if (!this.isCustomToneDirty) {
        this.isCustomToneDirty = true;
      }
    }
    insertGeneratedCaption(caption) {
      try {
        this.args.generatedCaption.usedAt = (0, _moment.default)().unix();
        this.args.generatedCaption.save();
        if (this.args.mediaItem) {
          _classPrivateMethodGet(this, _setDefaultCaption, _setDefaultCaption2).call(this, caption);
        } else if (this.isClickedFromFirstComment) {
          _classPrivateMethodGet(this, _setFirstComment, _setFirstComment2).call(this, caption);
        } else {
          _classPrivateMethodGet(this, _setPostCaption, _setPostCaption2).call(this, caption);
        }
        let source;
        if (!caption.originalGeneratedCaption && !this.args.isChangingToneOfCaption) {
          source = 'generated-from-scratch';
        } else if (caption.tone) {
          source = 'generated-from-tone-change';
        } else {
          source = 'generated-from-rephrasing';
        }
        this.segment.track(INSERTED_CAPTION_SEGMENT_EVENT, {
          ...this.defaultSegmentAttributes,
          'added-to-captions': !this.isClickedFromFirstComment,
          'added-to-first-comment': this.isClickedFromFirstComment,
          source,
          tone: (0, _formatToneForSegment.default)(caption.tone)
        });
        this.hasBeenInserted = true;
        setTimeout(() => {
          this.hasBeenInserted = false;
        }, 5000);
      } catch (error) {
        this.errors.handleAdapter(error);
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasBeenInserted", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "customTone", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isCustomToneSelected", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isCustomToneDirty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleCustomToneFormVisibility", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCustomToneFormVisibility"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputCustomTone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputCustomTone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertGeneratedCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "insertGeneratedCaption"), _class.prototype)), _class);
  function _getDelimiter2(currentCaption) {
    return currentCaption ? '\n\n' : '';
  }
  function _getUpdatedCaption2(currentCaption, caption) {
    return `${currentCaption}${_classPrivateMethodGet(this, _getDelimiter, _getDelimiter2).call(this, currentCaption)}${caption.generatedText}`;
  }
  function _setDefaultCaption2(caption) {
    const currentCaption = this.args.mediaItem.defaultCaption;
    (0, _object.set)(this.args.mediaItem, 'defaultCaption', _classPrivateMethodGet(this, _getUpdatedCaption, _getUpdatedCaption2).call(this, currentCaption, caption));
  }
  function _setFirstComment2(caption) {
    const currentCaption = this.args.post.firstComment;
    (0, _object.set)(this.args.post, 'firstComment', _classPrivateMethodGet(this, _getUpdatedCaption, _getUpdatedCaption2).call(this, currentCaption, caption));
  }
  function _setPostCaption2(caption) {
    const currentCaption = this.args.post.caption;
    (0, _object.set)(this.args.post, 'caption', _classPrivateMethodGet(this, _getUpdatedCaption, _getUpdatedCaption2).call(this, currentCaption, caption));
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListItemComponent);
});